import { z } from "zod";
import { metaSchema } from "./commun.zod";

export const ContactBaseSchema = z.object({
  nom: z.string().max(50, "Le nom ne peut pas dépasser 50 caractères").optional(),
  prenom: z.string().max(50, "Le prénom ne peut pas dépasser 50 caractères").optional(),
  fonction: z.string().max(50, "La fonction ne peut pas dépasser 50 caractères").optional(),
  email: z.string().email("Format d'email invalide").max(255, "L'email ne peut pas dépasser 255 caractères").optional(),
  groupe: z.string().max(50, "Le groupe ne peut pas dépasser 50 caractères").optional(),
  objet: z.string().max(50, "L'objet ne peut pas dépasser 50 caractères").optional(),
  message: z.string().max(100, "Le message ne peut pas dépasser 100 caractères").optional(),
  tel: z.string().max(255, "Le téléphone ne peut pas dépasser 255 caractères").optional(),
  etat: z.boolean().default(false),
});

export const ContactSchema = ContactBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().optional(),
  updated_at: z.date().optional(),
});

export const ContactCreateSchema = ContactBaseSchema.pick({
  nom: true,
  prenom: true,
  fonction: true,
  email: true,
  groupe: true,
  objet: true,
  message: true,
  tel: true,
});

export const ContactUpdateSchema = z.object({
  nom: z.string().max(50).optional(),
  prenom: z.string().max(50).optional(),
  fonction: z.string().max(50).optional(),
  email: z.string().email().max(255).optional(),
  groupe: z.string().max(50).optional(),
  objet: z.string().max(50).optional(),
  message: z.string().max(100).optional(),
  tel: z.string().max(255).optional(),
  etat: z.boolean().optional(),
});

export const ContactListResponseSchema = z.object({
  data: z.array(ContactSchema),
  meta: metaSchema,
});

export const ContactResponseSchema = z.object({
  data: ContactSchema,
  message: z.string().optional(),
});

export const ContactSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  etat: z.boolean().optional(),
  search: z.string().optional(),
  date_from: z.date().optional(),
  date_to: z.date().optional(),
  limit: z.number().default(10),
  page: z.number().default(1),
});

export type Contact = z.infer<typeof ContactSchema>;
export type ContactCreateInput = z.infer<typeof ContactCreateSchema>;
export type ContactUpdateInput = z.infer<typeof ContactUpdateSchema>;
export type ContactSelectInput = z.infer<typeof ContactSelectSchema>;

// Form-specific types for frontend
export type ContactFormData = ContactCreateInput;
export type ContactEditFormData = ContactUpdateInput;

// Utility types for different UI states
export type ContactDisplayItem = Pick<Contact, 'id' | 'nom' | 'prenom' | 'email' | 'objet' | 'etat' | 'created_at'>;
export type ContactTableItem = Pick<Contact, 'id' | 'nom' | 'prenom' | 'email' | 'objet' | 'etat' | 'created_at' | 'updated_at'>;

export type ContactResponse = z.infer<typeof ContactResponseSchema>;
export type ContactListResponse = z.infer<typeof ContactListResponseSchema>;

export const validateContactCreate = (data: unknown) => {
  return ContactCreateSchema.safeParse(data);
};

export const validateContactUpdate = (data: unknown) => {
  return ContactUpdateSchema.safeParse(data);
};

export const validateContactSelect = (data: unknown) => {
  return ContactSelectSchema.safeParse(data);
};